import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { Photo } from '@models/photo';
import { PhotoType } from 'src/app/types/photo.type';
import { CloseOverlayKeyboardDirective } from '../../directives/close-overlay.directives';
import { CameraFeedComponent } from '../camera-feed/camera-feed.component';
import { IconDirective } from '../../directives/icon.directive';
import { TranslateModule } from '@ngx-translate/core';
import { ConfirmValidIdComponent } from '../confirm-valid-id/confirm-valid-id.component';
import { CommonModule } from '@angular/common';
import { AbstractVerifyPhotoDirective } from '@directives/abstract-verify-photo.directive';
import { Session } from 'src/app/queries/generated';

@Component({
  selector: 'lv-retake-photo',
  templateUrl: './retake-photo.component.html',
  styleUrls: ['./retake-photo.component.scss'],
  imports: [
    CommonModule,
    CloseOverlayKeyboardDirective,
    CameraFeedComponent,
    IconDirective,
    TranslateModule,
    ConfirmValidIdComponent
  ]
})
export class RetakePhotoComponent extends AbstractVerifyPhotoDirective implements OnInit, OnDestroy {
  @Input() session!: Session;
  @Input() photoType!: PhotoType;
  @Output() photoAccepted = new EventEmitter();

  get fileName(): string {
    return `${this.photoType}.png`;
  }

  get assetSvg(): string {
    return this.photoType === 'face' ? 'assets/photo-oval.svg' : 'assets/id-rect.svg';
  }

  get facing(): string {
    return this.photoType === 'id' ? 'environment' : 'user';
  }

  ngOnInit() {
    if (this.photoType === 'id') {
      this.photoConfirmed = false;
      this.identificationChannel = this.subscribeToIdentificationChannel(this.session.token);

      this.photo$.subscribe((photo) => {
        if (photo) {
          this.identificationChannel.perform('validates_id', { photo: photo.payload });
        }
      });
    }

    super.ngOnInit();
  }

  ngOnDestroy() {
    this.unsubscribeFromIdentificationChannel();

    this.photo$.unsubscribe();
  }

  capture(photo: Photo) {
    if (this.photoType === 'id') {
      this.photoVerificationResponse$.next(null);
      this.photoVerificationLoading.set(true);
      this.showTryAgainButton = true; // Reset button visibility for new photo
    } else {
      this.photoVerificationResponse$.next({ success: true, need_confirmation: false });
    }

    super.capture(photo);
  }

  handlePhoto(photo: Photo) {
    this.photo$.next(photo);
  }

  accept() {
    this.photoAccepted.emit();
  }

  onPhotoConfirmed(confirmed: boolean) {
    this.photoConfirmed = confirmed;
  }
}
